import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BehaviorSubject, Observable } from 'rxjs';
import { StakeholderEmail } from "../shared/model/stakeholder-email";
import { EmailService } from '../shared/services/email.service';

export interface PreviewEmailDialogData {
  Id: string;
}

@Component({
  selector: 'app-preview-email-dialog',
  templateUrl: './preview-email-dialog.component.html',
  styleUrls: ['./preview-email-dialog.component.scss']
})
export class PreviewEmailDialogComponent implements AfterViewInit {

  @ViewChild('iFrame', { static: true }) iFrame: ElementRef;

  html: string;
  bccAddresses$ = new BehaviorSubject<string[]>(null);
  isExpand: boolean = false;
  isExpanded: boolean = false;
  bccAddressesFull$ = new BehaviorSubject<string[]>(null);
  stakeholderEmail$: Observable<StakeholderEmail>;

  constructor(
    public dialogRef: MatDialogRef<PreviewEmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PreviewEmailDialogData,
    private emailService: EmailService
    ) { }

  ngAfterViewInit() {
    this.stakeholderEmail$ = this.emailService.getEmailById(this.data.Id);
    this.stakeholderEmail$.subscribe(email => {
      this.bccAddressesFull$.next(email.BccAddresses.map(b => b.StakeEmail));
      if(this.bccAddressesFull$.value.length > 10)
      {
        this.bccAddresses$.next(this.bccAddressesFull$.value.slice(0, 10));
        this.isExpand = true;
      }
        
      this.createHtml(email);
    });
  }

  switchBcc() {
    this.isExpanded = !this.isExpanded;
  }

  private createHtml(email: StakeholderEmail){
    this.html = `
    ${email.HtmlStart}
    ${email.Header}
    ${email.Message}
    ${email.Footer}
    ${email.HtmlEnd}`;
    this.iFrame.nativeElement.srcdoc = this.html;
  }

}
